export default "__VITE_ASSET__DfP0WCaz__"